import '../../css/blocks/teamgrid.css';

// Wait for the window to fully load before initializing
window.addEventListener('load', () => {
  const teamgridBlocks = document.querySelectorAll('.teamgrid');
  
  if (teamgridBlocks.length) {
    // Initialize block-specific functionality here
  }
});
